import axios from 'axios';

export const reportsApi = {
  async getScreeningReport(params) {
    const response = await axios.get('/api/reports/screening', { params });
    return response.data;
  },
  /** Burger King: `{ scope: 'org' | 'teams', regions: [{ _id, name }] }` for the current user. */
  async getBkScope() {
    const response = await axios.get('/api/reports/bk/scope');
    return response.data;
  },
  async createExternalJobPost(data) {
    const response = await axios.post('/api/reports/external-job-post', data);
    return response.data;
  },
  async deleteExternalJobPost(jobId) {
    const response = await axios.delete(`/api/reports/external-job-post/${jobId}`);
    return response.data;
  },
  async importCandidates(data) {
    const response = await axios.post('/api/reports/import-candidates', data);
    return response.data;
  },
  async downloadChineseWokReport(startDate, endDate) {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    const response = await axios.get('/api/reports/chinese-wok-weekly', {
      params,
      responseType: 'blob'
    });
    return response.data;
  },
};
